export default __webpack_public_path__ + "static/Graphik-Semibold-Web-3882443ba2da425d05a824ba944fce82.ttf";